<template>
  <div class="mt-3">
    <v-card>
      <v-card-title>
        <span>{{ sectionLabel }}</span>
        <v-spacer />
        <v-btn color="primary" dark small @click.native="saveForm()">Add</v-btn>
      </v-card-title>
      <v-card-text class="p-n">
        <v-alert type="info" border="left" dense class="mb-2" v-if="sectionInfoBox">
          {{sectionInfoBox}}
        </v-alert>
        <v-row dense class="customCollapseHeader">
          <v-col cols="6" sm="4">Ceremony Date</v-col>
          <v-col cols="6" sm="4">Event Location</v-col>
          <v-col class="d-none d-sm-flex" sm="4">Event Description</v-col>
        </v-row>
        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item :name="i+1" v-for="(form,i) in items" :key="i">
            <template slot="title">
              <div class="customHead">
                <v-row dense>
                  <v-col cols="6" sm="4">
                    <el-tag type="primary" v-if="form.ceremony_date !== null && form.ceremony_date != undefined">{{ form.ceremony_date | day }}</el-tag>
                  </v-col>
                  <v-col cols="6" sm="4">{{ form.event_location }}</v-col>
                  <v-col class="d-none d-sm-flex" sm="4"><div class="pl-3 pr-2">{{ form.event_description }}</div></v-col>
                </v-row>
              </div>
            </template>
            <el-form :model="form" ref="form" label-position="top">
              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="Ceremony Date" prop="ceremony_date">
                    <el-date-picker :id="'ceremony_date' + form.id" @change="handleAutoSave(i, form)" value-format="yyyy-MM-dd" v-model="form.ceremony_date" v-on:click.native="checkDate($event)" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="Event Location" prop="event_location">
                    <el-input :id="'event_location' + form.id" @change="handleAutoSave(i, form)" v-model="form.event_location" style="width: 100%" />
                  </el-form-item>
                </v-col>
                <v-col cols="12">
                  <el-form-item label="Event Description" prop="event_description">
                    <el-input :id="'event_description' + form.id" @change="handleAutoSave(i, form)" v-model="form.event_description" style="width: 100%" />
                  </el-form-item>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="Number of Guests" prop="number_of_guests">
                    <el-input :id="'number_of_guests' + form.id" @change="handleAutoSave(i, form)" type="number" v-model="form.number_of_guests" style="width: 100%" />
                  </el-form-item>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="Who performed" prop="who_performed">
                    <el-input :id="'who_performed' + form.id" @change="handleAutoSave(i, form)" v-model="form.who_performed" style="width: 100%" />
                  </el-form-item>
                </v-col>
                <v-col cols="12">
                  <v-btn :loading="loading" :disabled="loading" color="primary" small @click.native="handleAutoSave(i,form)">
                    {{ $t('global.save') }}
                  </v-btn>
                  <v-btn color="error" small @click.native="deleteOpen(form,i)">Delete</v-btn>
                </v-col>
              </v-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import autosave from '@/mixins/autosave.js'

export default {
  props: {
    sectionId: {
      type: String
    },
    layout: {
      type: String
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    },
    datas: {
      type: Array
    }
  },
  mixins: [autosave],
  data() {
    return {
      edit: false,
      formItem: {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        event_description: null,
        event_location: null,
        ceremony_date: null,
        number_of_guests: null,
        who_performed: null
      },
      activeNames: -1,
      url: 'imms_table/application_sponsorship_ceremonies',
      loading: false,
      fields: ['event_description', 'ceremony_date', 'event_location', 'number_of_guests', 'who_performed'],
      items: []
    }
  },
  watch: {
    memberUID: function() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$Progress.start()
      var url = `table/application_sponsorship_ceremonies?filter=member_uid=${this.memberUID}&order=ceremony_date DESC`
      this.$store.dispatch('store/get', url)
        .then(response => {
          this.items = response.resource
          if (this.datas !== undefined) {
            this.checkItemsFields(response.resource, this.datas, this.sectionId)
          }
          this.$Progress.finish()
        })
        .catch(err => {
          this.$Progress.fail()
        })
    },
    nodeClear() {
      this.formItem = {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        event_description: null,
        event_location: null,
        ceremony_date: null,
        number_of_guests: null,
        who_performed: null
      }
      this.edit = false
    },
    saveForm() {
      this.nodeClear()
      this.edit = false
      this.items.push(this.formItem)
      var len = this.items.length
      this.activeNames = len
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.nodeClear()
    }
  }
}
</script>
